//ForEach Polly
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}


// external scripts
import $ from "jquery";
import debug from "bows";

// example of ES2015 modules loading & tree shaking
// import { emptyLinks } from "./base/_links";

import size from "./base/_size";
import isTouch from "./base/_isTouch";
import fitvid from "./base/_fitvid";
import keyboardFocus from "./base/_keyboardFocus";
//import smoothScroll from "./base/_smoothScroll";
import share from "./base/_share";
// import testing from './base/_testing';
// import loadScripts from "./base/_loadScripts";
// import tracking from "./base/_tracking";

// Site
import general from "./_general";
import nav from "./_nav";
import tabs from "./_tabs";
import cards from "./_cards";
import focus_tabs from "./_focus_tabs";
import jump from "./_jump";
import expert_sides from "./_expert-slider";
import home from "./_home";
import modal from "./_modal";
import search from "./_search";
import gTranslate from "./_gTranslate";

// Debugging
import overlay from "./_overlays";

// const $window = $(window);
// const $document = $(document);
// const log = debug("site");

class Site {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => this.ready());
		window.addEventListener('load', () => this.load());
	}

	ready() {
		$('html').removeClass('no-js').addClass('js');
		const log = debug("site:domReady");

		nav.init();
		// tracking.init();
		fitvid();
		isTouch.init();
		keyboardFocus.init();
		// smoothScroll.init();
		share.init();
		size.init();
		tabs.init();
		cards.init();
		focus_tabs.init();
		jump.init();
		expert_sides.init();
		home.init();
		modal.init();
		search.init();
		window.picturefill();
		// testing.init();

		general.init();
		overlay.init();

		log('document.DOMContentLoaded');
	}

	load() {
		const log = debug("site:windowLoad");
		log("window.onload");

		// example of ES2015 modules loading & tree shaking
		//emptyLinks();
	}

}

export default Site;
